import { useGetAllSIVReportsMutation } from 'src/services/SivReport';

export const useSivReportListView = () => {
  const [
    getAllSIVReports,
    {
      data: getAllsivReportData,
      error: getAllsivReportError,
      isError: getAllsivReportIsError,
      isLoading: getAllsivReportIsLoading,
      isSuccess: getAllsivReportIsSuccess
    }
  ] = useGetAllSIVReportsMutation();

  return {
    getAllSIVReports,
    getAllsivReportData,
    getAllsivReportError,
    getAllsivReportIsError,
    getAllsivReportIsLoading,
    getAllsivReportIsSuccess
  };
};
